// Generated by CoffeeScript 1.9.3
(function() {
  module.exports = {
    regular: 'a abbr address article aside audio b bdi bdo blockquote body button canvas caption cite code colgroup datalist dd del details dfn div dl dt em fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup html i iframe ins kbd label legend li map mark menu meter nav noscript object ol optgroup option output p pre progress q rp rt ruby s samp section select small span strong sub summary sup table tbody td textarea tfoot th thead time title tr u ul video'.split(' '),
    raw: 'style'.split(' '),
    script: 'script'.split(' '),
    "void": 'area base br col command embed hr img input keygen link meta param source track wbr'.split(' '),
    obsolete: 'applet acronym bgsound dir frameset noframes isindex listing nextid noembed plaintext rb strike xmp big blink center font marquee multicol nobr spacer tt'.split(' '),
    obsolete_void: 'basefont frame'.split(' ')
  };

}).call(this);
